<template>
  <div>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs6>
          <orderSnapShotTable :order="order" :order_eta="order_eta" />
        </v-flex>
        <v-flex xs6>
          <notesManager :order="order" />
        </v-flex>
        <v-flex xs12>
          <DataEntryForms :order="order"> </DataEntryForms>
        </v-flex>
        <v-flex xs12 v-if="order.status.slug=='data-entry'">
          <v-layout>
            <v-flex xs12>
              <div class="text-xs-center" style="text-align: right;">
                <v-btn color="rtsPrimary" dark @click="sendToQA" :loading="loading">Send To QA</v-btn>
              </div>
            </v-flex>
            <!-- <v-flex xs1>
              <div class="text-xs-center" style="text-align: center;">
                <v-btn color="rtsPrimary" dark>Cancel</v-btn>
              </div>
            </v-flex> -->
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import DataEntryForms from '@/components/dataEntryForms.vue'
import orderSnapShotTable from '@/components/orderSnapShotTable.vue'
import notesManager from '@/components/notesManager.vue'
import { PATCHORDER, POSTNOTE } from '@/store/actions.type'
import Vue from 'vue'

Vue.filter('formatAddress', function (value) {
  if (value) {
    return value.street + ', ' + value.county.name + ', ' + value.zip_code
  }
})

Vue.filter('formatDate', function (value) {
  if (value) {
    return new Date(value).toLocaleString(
      'en-US', { timeZone: 'America/Los_Angeles', hourCycle: 'h23' }
    ).replace(',', '')
  }
})

export default {
  name: 'DataEntry',
  components: {
    orderSnapShotTable,
    notesManager,
    DataEntryForms
  },
  data () {
    return {
      files: [],
      selected: [],
      loading: false
    }
  },
  props: {
    order: null,
    documentPath: null,
    order_eta: null
  },
  mounted () {
  },
  methods: {
    sendToQA () {
      this.loading = true
      let payload = {
        id: this.order.id,
        status: 5
      }
      this.$store.dispatch(PATCHORDER, payload).then(response => {
        let noteCreatedBy = JSON.parse(window.localStorage.getItem('auth')).user_data
        this.order = response
        this.loading = false
        let assignerNotePayload = {
          note: `Order moved to QA Stage by ${noteCreatedBy.username}`,
          order: this.order.id,
          type: 'Order'
        }
        this.$store.dispatch(POSTNOTE, assignerNotePayload).then(noteResponse => {
          console.log(noteResponse)
          this.$emit('updateOrder', this.order)
        })
      })
    }
  }
}
</script>

<style>
body {
  font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  font-size: 14px;
  line-height: 1.428571429;
  color: #333;
  background-color: #e7edf0;
}
.order-data-table {
  height: 100vh;
  position: fixed;
  bottom: 0;
  width: 100%;
  margin: auto
}
.v-data-table td {
  font-size: 10px;
  font-weight: bold;
}
.v-chip__content {
  font-size: 10px;
  font-weight: bold;
}
.v-data-table td, .v-data-table th {
  padding: 0 5px;
}

.statusTab {
    color: #fff !important;
    background-color: #00abab !important;
    border-color: #00abab;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.activeStatusTab {
    background-color: #4e6692 !important;
    border-color: #4e6692 !important;
    color: #fff !important;
    width: 120px;
    height: 50px !important;
    display: table-cell;
    vertical-align: middle;
    margin-right: 40px;
    font-size: 10px !important;
    font-weight: 900;
}

.statusTabLine {
  width: 100%;
}

.statusTabLine:before {
    width: 96%;
    background: #d9544f;
    content: "";
    height: 1px;
    position: relative!important;
    padding: 2px;
    top: 40px!important;
    left: 0!important;
    margin: auto;
    display: inline-block;
}

.orderContainer {
  width: 90%;
  margin: auto;
  background-color: white;
  min-height: 800px;
}

.orderHeader {
  width: 90%;
  margin: auto;
  padding: 0px;
  border-bottom: none;
  font-family: 'Open Sans', sans-serif;
  font-size: 24px;
  font-weight: 600;
  padding-top: 10px;
  padding-bottom: 10px;
}

.firstPan > .v-toolbar__content {
    height: 0px !important;
}
.v-sheet--tile {
    height: 60px !important;
}
</style>
